var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",class:_vm.tileClass},[_vm._l((_vm.tile.crowns),function(i){return _c('v-icon',{key:i,attrs:{"color":"orange"}},[_vm._v(" mdi-crown ")])}),(_vm.tile.crowns === 0)?_c('v-icon',[_vm._v(" mdi-pen ")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }